import { IconButtonDropdownNew } from '@lune-fe/lune-ui-lib'
import Co2Icon from '@mui/icons-material/Co2'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const ClientAccountsContextMenu: FC<{
    accountId: string
}> = ({ accountId }) => {
    const estimatesWithAccountIdFilter = `/calculate-emissions?account_id=${accountId}`
    const navigate = useNavigate()

    const [open, setOpen] = useState<boolean>(false)

    return (
        <IconButtonDropdownNew
            sx={{ ...(open && { opacity: '1 !important' }) }}
            onToggle={(isOpen) => setOpen(isOpen)}
            menuAutoWidth
            icon={<MoreVertOutlinedIcon />}
        >
            <IconButtonDropdownNew.MenuItem
                icon={<Co2Icon />}
                disabled={!estimatesWithAccountIdFilter}
                title={'View emissions'}
                onClick={() => navigate(estimatesWithAccountIdFilter)}
            />
        </IconButtonDropdownNew>
    )
}

export default ClientAccountsContextMenu
